document.addEventListener('DOMContentLoaded', function() {
    // Check if the password fields exist
    const passwordField = document.getElementById('reg_password');
    const confirmField  = document.getElementById('reg_password2');
    const toggleBtn     = document.getElementById('toggle-password');
    const toggleBtn2    = document.getElementById('toggle-password2');
  
    // Only run the toggle code if these elements are present
    if (passwordField && toggleBtn) {
      toggleBtn.addEventListener('click', function() {
        if (passwordField.type === 'password') {
          passwordField.type = 'text';
        } else {
          passwordField.type = 'password';
        }
      });
    }
  
    if (confirmField && toggleBtn2) {
      toggleBtn2.addEventListener('click', function() {
        if (confirmField.type === 'password') {
          confirmField.type = 'text';
        } else {
          confirmField.type = 'password';
        }
      });
    }
    
  });
  